<template>
    <TableLayout>
<!--        :permissions="['business:company:query']"-->
        <!-- 搜索表单 -->
<!--        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>-->
<!--            <el-form-item label="组织名称" prop="name">-->
<!--                <el-input v-model="searchForm.name" placeholder="请输入组织名称" @keypress.enter.native="search"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="所属上级组织" prop="parentName">-->
<!--                <el-input v-model="searchForm.parentName" placeholder="请输入所属上级组织" @keypress.enter.native="search"></el-input>-->
<!--            </el-form-item>-->
<!--            <section>-->
<!--                <el-button type="primary" @click="search">搜索</el-button>-->
<!--                <el-button @click="reset">重置</el-button>-->
<!--            </section>-->
<!--        </el-form>-->
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:company:create', 'business:company:sync']">
<!--                <li><el-button type="primary" v-permissions="['business:company:create']" @click="$refs.OperaInternalCompanyWindow.open('新建企业')">新建</el-button></li>-->
                <li><el-button type="primary"  v-permissions="['business:company:sync']" :loading="loading" @click="synchronous()">同步</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="list"
                stripe
                :tree-props="{children: 'childList'}"
                row-key="id"
                :expand-row-keys="[list && list.length > 0 ? list[0].id.toString() : '']"
                @selection-change="handleSelectionChange"
            >
<!--                <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column prop="name" label="组织名称" min-width="100px"></el-table-column>
                <el-table-column prop="editDate" label="最后更新时间" min-width="100px"></el-table-column>
<!--                <el-table-column-->
<!--                    label="操作"-->
<!--                    width="230"-->
<!--                    fixed="right"-->
<!--                >-->
<!--                    <template slot-scope="{row}">-->
<!--                        <el-button type="text" @click="$refs.OperaInternalCompanyWindow.open('编辑企业信息', row)" icon="el-icon-edit" v-permissions="['business:company:update']">编辑</el-button>-->
<!--                        <el-button type="text" @click="$refs.OperaInternalCompanyWindow.open('新建子级', { disable: true, parentId: row.id })" icon="el-icon-plus">新建子级</el-button>-->
<!--                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:company:delete']">删除</el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
        </template>
        <!-- 新建/修改 -->
        <OperaInternalCompanyWindow ref="OperaInternalCompanyWindow" :list="list" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import { companySync } from '@/api/business/company'
import OperaInternalCompanyWindow from '@/components/business/OperaInternalCompanyWindow'
import { memberSync } from '@/api/business/member'
export default {
  name: 'internalCompany',
  extends: BaseTable,
  components: { TableLayout, OperaInternalCompanyWindow },
  data () {
    return {
      // 搜索
      loading:false,
      searchForm: {
        type: 1
      },
      list: [],
      total: 0
    }
  },
  created () {
    this.config({
      module: '企业信息表',
      api: '/business/company',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    // 页码变更处理
    handlePageChange (pageIndex) {
      this.__checkApi()
      this.isWorking.search = true
      this.api.fetchList(this.searchForm.type)
        .then(data => {
          this.list = data
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    },
    // 同步信息
    async synchronous () {
      this.$dialog.actionConfirm('操作确认提醒', '您确认同步全部信息吗？')
        .then(() => {
          this.loading = true
          companySync({})
            .then(res => {
              this.$tip.apiSuccess(res || '同步成功')
              this.search()
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    }
  }
}
</script>
